<div class="main-wrap">
  <div class="left-box">
    Booking ID: {{booking!.id!}}
    <div class="booking-info-table">
      <table>
        <tr>
          <td>
              <p>
                  First name:&nbsp;
                </p>

          </td>
          <td>
              {{booking!.student!.firstName}}
          </td>
        </tr>
        <tr>
          <td>
              <p>
                  Last name:&nbsp;
                </p>
          </td>
          <td>
              {{booking!.student!.lastName}}
          </td>
        </tr>
        <tr>
          <td>
              <p>
                  Start date:&nbsp;
                </p>
          </td>
          <td>
              {{booking!.startDate.toDate() | date: "dd/MM/yyyy"}}
          </td>
        </tr>
        <tr>
          <td>
              <p>
                  End date:&nbsp;
                </p>
          </td>
          <td>
              {{booking!.endDate.toDate() | date: "dd/MM/yyyy"}}
          </td>
        </tr>
        <tr>
          <td>
              <p>
                  Duration: 
                </p>
          </td>
          <td>
              {{duration}} {{weeks}}
          </td>
        </tr>
      </table>
      <div *ngIf="vademecum">
        <table>
          <tr>
            <td>
                <p>
                    Student GSM: 
                  </p>
            </td>
            <td>
                {{vademecum.studentMobile}}
            </td>
          </tr>
          <tr>
            <td>
                <p>
                    Parent 1 First name: 
                  </p>
            </td>
            <td>
                {{vademecum.firstParentFirstName | titlecase}}
            </td>
          </tr>
          <tr>
            <td>
                <p>
                    Parent 1 Last name: 
                  </p>
            </td>
            <td>
                {{vademecum.firstParentLastName | titlecase}}
            </td>
          </tr>
          <tr>
            <td>
                <p>
                    Parent 1 GSM:
                  </p>
            </td>
            <td>
                {{vademecum.firstParentMobile}}
            </td>
          </tr>
        </table>
            <div class="input-box"></div>
            <div class="input-box"></div>
      </div>
      
    </div>

  </div>
  <div class="right-box">
    <div class="picture-wrap">
      <img [src]="picture" *ngIf="picture" class="student-picture">
    </div>
  </div>

</div>